import { SignupService } from './../services/signup.service';
import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageemitterService } from '../services/messageemitter.service';
import { UserInformationService } from '../services/userInformation.service';
import { LoginService } from '../services/login.service';
import { LocalstorageService } from '../services/localstorage.service';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  loginDetails: UntypedFormGroup;
  submitted: boolean = false;
  role: string = '';

  public loading = false;
  public Loginstatus: boolean = false;
  public invalidCredentials: boolean = false;
  customResponse: any;
  sBrowser = '';
  invalidCreds: any;
  userEmail: any;
  showSignUpBtn = true;
  hideSignUpBtn = true;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private loginService: LoginService,
    private localStorageService: LocalstorageService,
    private userInformationService: UserInformationService,
    public dialog: MatDialog,
    private signupService: SignupService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.showSignUpBtn = this.signupService.getShowMessage();
    const sUsrAg = window.navigator.userAgent;
    if (sUsrAg.indexOf('Firefox') > -1) {
      this.sBrowser = 'Mozilla Firefox';
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf('Opera') > -1) {
      this.sBrowser = 'Opera';
    } else if (sUsrAg.indexOf('Trident') > -1) {
      this.sBrowser = 'Microsoft Internet Explorer';
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf('Edge') > -1) {
      this.sBrowser = 'Microsoft Edge';
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf('Chrome') > -1) {
      this.sBrowser = 'Google Chrome or Chromium';
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf('Safari') > -1) {
      this.sBrowser = 'Apple Safari';
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
      this.sBrowser = 'unknown';
    }
    this.loginDetails = this.formBuilder.group({
      username: '',
      password: '',
    });
  }

  login(): void {
    this.signupService.setShowMessage(true);
    this.loading = true;
    let uname = this.loginDetails.get('username').value;
    let pwd = this.loginDetails.get('password').value;
    this.invalidCreds = (uname) == '' ? 'Please Enter User Name' : '';
    this.invalidCreds = (pwd) == '' ? 'Please Enter Password' : this.invalidCreds;
    this.invalidCreds = (uname == '' && pwd == '') ? 'Please Enter User Name and Password' : this.invalidCreds;
    if (this.invalidCreds != '') {
      this.invalidCredentials = true;
      this.submitted = false;
      this.loading = false;
      return;
    }
    this.submitted = true;
    if (this.loginDetails.invalid) {
      this.loading = false;
      return;
    }


    this.loginService.insertBrowserloggingInformation(this.loginDetails.get('username').value, this.sBrowser).subscribe(() => { });
    this.loginService.userAuthentication(uname, pwd)
      .subscribe((response: any) => {
        MessageemitterService.get('loginStatus').emit(['true']);
        this.localStorageService.setAuthorizationData(response);
        sessionStorage.setItem('currentUserEmail', uname);
        sessionStorage.setItem('emailInLocalStorage', uname);
      },
        (err: HttpErrorResponse) => {
          this.loading = false;
          this.invalidCredentials = true;
          console.error('LoginComponent_login', err);
          return;
        }, () => {

          if (uname == "superadmin@ttnfs.com") {
            this.loading = false;
            this.openConfirmationDialog();
          } else {
            this.loginUser();
          }
        },
      );
  }


  loginUser() {
    this.loading = true;
    this.userInformationService.getUserInformationByEmail(sessionStorage.getItem('currentUserEmail')).subscribe((res) => {
      const userDetails = {
        'firstname': res.firstname,
        'middlename': res.middlename,
        'lastname': res.lastname,
        'email': res.email,
        'billingEmail': res.billingEmail,
        'phone': res.phone,
        'breakDownPhone': res.officePhone,
        'address': res.address,
        'city': res.city,
        'state': res.stateTypeId,
        'zip': res.zip,
        'isDemoComplete': res.isDemoComplete,
        'subScriptionType': res.subScriptionType,
        'viewProviderInvoice': res.viewProviderInvoice,
      };
      sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
      sessionStorage.setItem('companyName', res.companyName);
      sessionStorage.setItem('customerTimezone', res.timeZoneTypeId == 0 ? 'America/New_York' : res.timeZoneTypeId);
      this.customResponse = res;
      this.userEmail = this.customResponse.email;
      this.getSisenseAnalytics();
    }, (err) => {
      this.loading = false;
      console.error('LoginComponent_loginUser', err);
    },
      () => {

        sessionStorage.setItem('customerUserInformationId', this.customResponse.customerUserInformationId);
        sessionStorage.setItem('legacyCustomerKeyId', this.customResponse.legacyCustomerKeyId);
        sessionStorage.setItem('fleetCustomerId', this.customResponse.fleetCustomerId);
        sessionStorage.setItem('customerParentInformationID', this.customResponse.customerParentInformationID);
        sessionStorage.setItem('userAssociation', this.customResponse.userAssociation);
        sessionStorage.setItem('image', this.customResponse.image);
        sessionStorage.setItem('subCustomerId', this.customResponse.legacySubCustomerKey);
        sessionStorage.setItem('doNotShowTour', this.customResponse.doNotShowTour);
        sessionStorage.setItem('approvalAvailabilityStart', this.customResponse.approvalAvailabilityStart);
        sessionStorage.setItem('approvalAvailabilityStop', this.customResponse.approvalAvailabilityStop);
        sessionStorage.setItem('approvalLimitRepairsTow', this.customResponse.approvalLimitRepairsTow);
        sessionStorage.setItem('approvalLimitTire', this.customResponse.approvalLimitTire);
        sessionStorage.setItem('assignedTo', this.customResponse.assignedTo);
        sessionStorage.setItem('available24Hours', this.customResponse.available24Hours);
        sessionStorage.setItem('notAnApprover', this.customResponse.notAnApprover);
        sessionStorage.setItem('weekDay', this.customResponse.weekDay);
        sessionStorage.setItem('title', this.customResponse.title);
        sessionStorage.setItem('hierachy', this.customResponse.hierachy);
        sessionStorage.setItem('view', this.customResponse.view);
        sessionStorage.setItem('role', this.customResponse.role);
        sessionStorage.setItem('loggedInRegionName', this.customResponse.regionName);
        sessionStorage.setItem('loggedInDivisionName', this.customResponse.divisionName);
        sessionStorage.setItem('loggedInLocationName', this.customResponse.locationName);

        sessionStorage.setItem('ersSubcustomerId', this.customResponse.ersSubcustomerId);
        sessionStorage.setItem('ersDivisionId', this.customResponse.ersDivisionId);
        sessionStorage.setItem('ersLocationId', this.customResponse.ersLocationId);
        sessionStorage.setItem('fleetSubcustomerId', this.customResponse.fleetSubcustomerId);
        sessionStorage.setItem('fleetDivisionId', this.customResponse.fleetDivisionId);
        sessionStorage.setItem('fleetLocationId', this.customResponse.fleetLocationId);
        sessionStorage.setItem('agreementURL', this.customResponse.agreementTemplateURL);
        sessionStorage.setItem('subscriptionType', this.customResponse.subScriptionType);
        sessionStorage.setItem('restrictWOsDate', this.customResponse.restrictWOsDate ? this.customResponse.restrictWOsDate : '');
        sessionStorage.setItem('isAgreementAccepted', this.customResponse.isAgreementAccepted);

        this.navigateToDashboard();
        // this.loading = false;
      });
  }

  navigateToDashboard() {
    this.router.navigate(['/pages']);
    // if (this.customResponse.isAgreementAccepted === 1) {
    // } else {
    //   this.signupService.setIsAgreementAccepted(true);
    //   const companyDetailsData = { email: this.userEmail }
    //   this.signupService.setCompanyDetails(companyDetailsData);
    //   this.router.navigate(['/termsAndConditions'], { relativeTo: this.route });
    //   return false;
    // }
  }

  getSisenseAnalytics() {
    const filter = {
      customerKey: this.customResponse.legacyCustomerKeyId,
      userAssocitionKey: this.customResponse.userAssociation
    };
    this.userInformationService.getAnalyticsDetails(filter).subscribe((res) => {
      sessionStorage.setItem('analytics', JSON.stringify(res.body));
    }, (error) => {
      console.error('LoginComponent_getSisenseAnalytics', error);
    });
    return false;
  }

  changeInvalidCredentialsStatus() {
    this.invalidCredentials = false;
  }

  isLoggedIn() {
    return true;
  }

  signup() {
    this.router.navigate(['/signup']);
  }

  openCustomerListPopup() {
    let dialogRef = this.dialog.open(CustomerListComponent, {
      hasBackdrop: true,
      width: "50%",
      position: {
        top: "1%",
        bottom: "1%"
      },
      data: {}
    });

    dialogRef.afterClosed().subscribe(value => {

      if (value == 1) {
        this.loginUser();
      }
    });

  }

  openConfirmationDialog() {
    let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: false
    });
    dialogRef.componentInstance.confirmMessage = "Do you want to login with other user ?"

    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.openCustomerListPopup();
      } else {
        sessionStorage.clear();
      }
      dialogRef = null;
    });
  }

}
